export default "__VITE_ASSET__CUW1yOGQ__"